import React from 'react';
import { Empty } from 'antd';

const NoRowsOverlay = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        padding: '2rem',
      }}
    >
      <Empty
        style={{
            color: 'var(--medium-light-grey-color)',
        }}
        description={
            <>
            <h3 style={{
                color: 'var(--medium-light-grey-color)',
            }}>
                No Data Available
            </h3>
            <p style={{
                color: 'var(--medium-light-grey-color)',
            }}>
               Please try a different date range or contact support if you believe this is an error.
            </p>
            </>
        }
      /> 
    </div>
  );
};

export default NoRowsOverlay; 